import {RolandStructuredObject} from "../RolandStructuredObject.js";
import {RolandVariableArrayWithAppendedData,OffsetAndLengthObject} from "../RolandVariableArrayWithAppendedData.js";

/**
 * Overriden to add the childObjectLength
 */
export class MCLPD extends RolandVariableArrayWithAppendedData {
    constructor(file, data,parent,start,length,type,...childArrayTypes) {
        super(file,data,parent,start,length,type,...childArrayTypes);
        this.childObjectLength = 16;
        this.appendedDataChildType = MCLPDSampleData;
    }
}

/**
 * Item in the MCLPD array - contains offset and length of the data
 */
export class MCLPDItem extends OffsetAndLengthObject {
    constructor(file, data, parent, start, length, description) {
        super(file, data, parent, start, length, description);
        this.offsetBytePosition=4;
        this.lengthBytePosition=0;
    }
}

/**
 * Sample data appended to the end of the MCLPD array
 */
export class MCLPDSampleData extends RolandStructuredObject {
    constructor(file, data, parent, start, length, description) {
        super(file, data, parent, start, length, description);
    }
}